import { render, staticRenderFns } from "./ConstructionAndRenovation.vue?vue&type=template&id=56eca0e3&scoped=true&"
import script from "./ConstructionAndRenovation.vue?vue&type=script&lang=js&"
export * from "./ConstructionAndRenovation.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionAndRenovation.vue?vue&type=style&index=0&id=56eca0e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eca0e3",
  null
  
)

export default component.exports